<template>
  <div class="wrap">
    <div class="pcRoleInfo">
      <div class="infoList">
        <van-field
          readonly
          clickable
          name="picker"
          :value="game_name"
          :label="$t('pay.title.game')"
          :placeholder="$t('pay.title.gamePlaceholder')"
          @click="selectRoleInfo(1)"
        />
      </div>
      <div>
        <van-field
          readonly
          clickable
          name="picker"
          :value="server_name"
          :label="$t('pay.title.server')"
          :placeholder="$t('pay.title.serverPlaceHolder')"
          @click="selectRoleInfo(2)"
        />
      </div>
      <div>
        <van-field
          readonly
          clickable
          name="picker"
          :value="role_name"
          :label="$t('pay.title.role')"
          :placeholder="$t('pay.title.rolePlaceHolder')"
          @click="selectRoleInfo(3)"
        />
      </div>
      <div style="margin-top: 0.3rem; padding: 0 0.3rem">
        <van-button type="primary" block round size="small" @click="linkPayIndex">{{$t('common.confirmRole')}}</van-button>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
    </van-popup>
  </div>
</template>
<script>
import { axiosServer } from '@/api/http';
import { getSign } from '@/api/utils';
import { useDialog } from '@/features/dialog';
export default {
  data() {
    return {
      showPicker: false,
      columns: [],
      token: '',
      gameList: [],
      serverList: [],
      roleList: [],
      app_key: '1df869f2e620513484ddbd5521313a60',
      value: '',
      game_id: '',
      area: '',
      popType: '',
      game_name: '',
      server_name: '',
      server_id: '',
      role_name: '',
      role_id: '',
    };
  },
  setup() {
    const { confirmDialog } = useDialog();
    return {
      confirmDialog,
    };
  },
  computed: {
    mapOptions() {
      return {
        1: this.gameList,
        2: this.serverList,
        3: this.roleList,
      };
    },
    mapSelectValue() {
      return {
        1: this.game_name,
        2: this.server_name,
        3: this.role_name,
      };
    },
  },
  created() {
    // 先通过postmessage传当前窗口状态到上层使用者
    const payload = { action: 'min' };
    window.parent.postMessage(payload, '*');
    console.log('成功发送数据了')
      if (this.$route.query.token) {
        localStorage.setItem('pctoken', this.$route.query.token);
        this.token = this.$route.query.token ||'';
      } else {
        this.token = localStorage.getItem('pctoken')
      }
    this.getRoleLastLogin();
    this.getGameList();
    localStorage.setItem('pc_pay_page', 1);
  },
  methods: {
    onConfirm(data) {
      console.log(data);
      if (this.popType == 1) {
        this.game_id = data.game_id;
        this.area = data.area;
        localStorage.setItem('area', this.area);
        this.game_name = data.subpackage_name;
        this.getServerList();
      }
      if (this.popType == 2) {
        this.server_name = data.server_name;
        this.server_id = data.server_id;
        this.getRoleList();
      }
      if (this.popType == 3) {
        this.role_name = data.role_name;
        this.role_id = data.role_id;
      }
      this.showPicker = false;
    },
    selectRoleInfo(type) {
      this.showPicker = true;
      this.popType = type;
      console.log(this.mapOptions);
      this.columns = this.mapOptions[type];
    },
    getGameList() {
      axiosServer({
        url: 'gameList',
        type: 'post',
        params: {
          token: this.token,
          sign: getSign(this.app_key, { token: this.token }),
        },
      }).then((res) => {
        let resa = res.data;
        console.log(resa.data, '222');
        if (resa.ret == 0) {
          resa.data &&
            resa.data.forEach((item) => {
              item.text = item.subpackage_name;
              item.id = item.game_id;
            });
          this.gameList = resa.data;
        } else {
          this.confirmDialog({
            message: resa.msg,
          });
        }
      });
    },
    getServerList() {
      axiosServer({
        url: 'serverList',
        type: 'post',
        params: {
          token: this.token,
          game_id: this.game_id,
          area: this.area,
          sign: getSign(this.app_key, { token: this.token, game_id: this.game_id, area: this.area }),
        },
      }).then((res) => {
        let resa = res.data;
        if (resa.ret == 0) {
          resa.data &&
            resa.data.forEach((item) => {
              item.text = item.server_name;
              item.id = item.server_id;
            });
          this.serverList = resa.data;
        } else {
          this.confirmDialog({
            message: resa.msg,
          });
        }
      });
    },
    getRoleList() {
      axiosServer({
        url: 'roleList',
        type: 'post',
        params: {
          token: this.token,
          game_id: this.game_id,
          area: this.area,
          server_id: this.server_id,
          sign: getSign(this.app_key, {
            token: this.token,
            game_id: this.game_id,
            area: this.area,
            server_id: this.server_id,
          }),
        },
      }).then((res) => {
        let resa = res.data;
        if (resa.ret == 0) {
          resa.data &&
            resa.data.forEach((item) => {
              item.text = item.role_name;
              item.id = item.role_id;
            });
          this.roleList = resa.data;
        } else {
          this.confirmDialog({
            message: resa.msg,
          });
        }
      });
    },
    // 获取角色最近登录
    getRoleLastLogin() {
      axiosServer({
        url: 'lastLoginRole',
        type: 'post',
        params: {
          token: this.token,
          sign: getSign(this.app_key, { token: this.token }),
        },
      }).then((res) => {
        let resa = res.data;
        if (resa.ret == 0 && resa.data.game_id) {
          this.game_id = resa.data.game_id;
          this.game_name = resa.data.subpackage_name;
          this.role_id = resa.data.role_id;
          this.role_name = resa.data.role_name;
          this.server_id = resa.data.server_id;
          this.server_name = resa.data.server_name;
          this.area = resa.data.area;
          this.getServerList();
          localStorage.setItem('area', this.area);
        } else {
          this.confirmDialog({
            message: resa.msg,
          });
        }
      });
    },
    linkPayIndex() {
      if (!this.game_id && !this.server_id && !this.role_id) {
        this.confirmDialog({
            message: this.$t('pay.dialogMessage.confirmCharacter')
        });
        return
      }
      this.$router.push({
        path: '/pcIndex',
        query: { game_id: this.game_id, area: this.area, server_id: this.server_id, role_id: this.role_id },
      });
    },
  },
};
</script>
<style>
.wrap {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pcRoleInfo {
  width: 100%;
}
.infoList {
}
</style>